import { render, staticRenderFns } from "./show-v2.vue?vue&type=template&id=6a44140c&scoped=true&"
import script from "./show-v2.vue?vue&type=script&lang=js&"
export * from "./show-v2.vue?vue&type=script&lang=js&"
import style0 from "./show-v2.vue?vue&type=style&index=0&id=6a44140c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a44140c",
  null
  
)

export default component.exports